module.exports = __webpack_public_path__ + "static/media/create_card.22db11eb.gif";